import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "icon-back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _openBlock(), _createElementBlock("div", {
    class: "c-navigation-bar hairlines",
    style: _normalizeStyle([$options.rootStyles, $options.statusBarRootStyles])
  }, [_createElementVNode("div", {
    class: "c-navigation-bar-wrap",
    style: _normalizeStyle([$options.wrapStyles, $options.statusBarWrapStyles])
  }, [_createElementVNode("div", {
    class: "c-navigation-bar-back",
    style: _normalizeStyle($options.backStyles),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleBack && $options.handleBack(...args))
  }, [_renderSlot(_ctx.$slots, "left", {
    opacity: $options.alpha
  }, () => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_svg_icon, {
    "icon-class": "arrow-left"
  })])])], 4), _createElementVNode("div", {
    class: "c-navigation-bar-title ellipsis",
    style: _normalizeStyle($options.titleStyles)
  }, [_renderSlot(_ctx.$slots, "title", {
    opacity: $options.alpha
  }, () => [_createTextVNode(_toDisplayString($props.title), 1)])], 4), _createElementVNode("div", {
    class: "c-navigation-bar-right",
    style: _normalizeStyle($options.rightStyles)
  }, [_renderSlot(_ctx.$slots, "right")], 4)], 4)], 4);
}